<!-- eslint-disable -->
<script setup>
import { useI18n } from 'vue-i18n';
import { useRegisterStore } from '../../stores/register';
import { useLanguagesStore } from '../../stores/languages';

const { t } = useI18n();
const registerStore = useRegisterStore();
const languagesStore = useLanguagesStore();
</script>

<template>
	<div class="register-form-field">
		<label>{{$t('account.account_preferences.language')}}</label>
		<select @change="registerStore.validateLanguage" name="" v-model="registerStore.register_input_fields.language_id" class="form-input form-control" id="address-country">
			<option :value="null" disabled>{{ $t('account.register.choose_language') }}</option>
			<option v-for="language in languagesStore.getLanguages" :key="language.id" :value="language.id">{{ language.name }}</option>
		</select>
		<div class="register-form-list" v-if="registerStore.register_errors.language_id.error">
			<div class="password-meter">
				<div class="password-meter-bar">
					<div class="password-meter-bar-inn"></div>
				</div>
			</div>
			<p>
				<img src="@/assets/svgs/cross.svg" alt=""/>
				&nbsp;
				<span v-if="registerStore.register_errors.language_id.error === 'error_select_language'">
					{{ $t('account.register.error_select_language') }}
				</span>
				<span v-else-if="registerStore.register_errors.hasOwnProperty('language_id')">
					{{ registerStore.register_errors.language_id.error }}
				</span>

			</p>
		</div>
	</div>
</template>

<style scoped>
.register-form-main .register-outer-form .register-inner-form .password-meter .password-meter-bar {
	background-color:var(--red);
	margin-bottom:5px;
}
.register-form-main .register-form-list {
	margin-top:unset;
	padding-top:5px;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form select {
	background-position: 5%;
}
html[dir="rtl"] .register-form-main .register-outer-form .register-inner-form .form-input {
	padding: 10px 15px 10px 15px;
}
</style>